<app-tva-custom-selection></app-tva-custom-selection>
<br />
<div id="grid-wrapper" style="width: 100%">
  <ag-grid-angular
    [domLayout]="'normal'"
    [style.height]="partsAgreementOverviewData.length > 20 ? '680px' : 'none'"
    [gridOptions]="gridOptions"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [pagination]="false"
    [multiSortKey]="multiSortKey"
    [tooltipShowDelay]="tooltipShowDelay"
    [enableBrowserTooltips]="true"
    [components]="frameworkComponents"
    [excelStyles]="excelStyles"
    (gridReady)="onGridReady($event)"
    class="ag-theme-alpine_customize"></ag-grid-angular>
</div>

<pas-sidebar-holder [hasNavbar]="true">
  <div class="sidebar-contents">
    <div class="sidebar-element sidebar-row">
      <ul class="navbar-nav">
        <ng-container>
          @if (canAddPartsAgreement) {
            <li class="nav-item">
              <a (click)="onBtnAddSupplierPartsAgreement()" class="nav-link link-sidebar">
                <i class="material-icons">add_circle_outline</i>
                <span class="hidden-md-down" ui-test-id="addPartAgreementBtn">
                  {{ 'partsAgreementsOverview.btnAdd' | translate }}
                </span>
              </a>
            </li>
          }
          <app-tva-custom-sidebar
            [numberOfButtonsVisibleSidebar]="numberOfButtonsVisibleSidebar"></app-tva-custom-sidebar>
        </ng-container>
      </ul>
    </div>
  </div>
</pas-sidebar-holder>

<ng-template #modalTemplate>
  <tur-generic-modal-content
    [acceptanceAllowed]="(isFormValidAndModalNotOpenInDisplayOnlyMode$ | async) && canAddPartsAgreement"
    (confirm)="onConfirm()"
    (cancel)="onCancel()"
    confirmationMessage=""
    modalTitle="{{ 'partsAgreement.edit' | translate }}"
    acceptButtonLbl="{{ 'SAVE' | translate }}"
    cancelButtonLbl="{{ 'CANCEL' | translate }}">
    <app-parts-agreement-editor></app-parts-agreement-editor>
  </tur-generic-modal-content>
</ng-template>
